"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _DynoSchedulingForm = _interopRequireDefault(require("./DynoSchedulingForm"));

var _DynoSchedulingOptions = _interopRequireDefault(require("./DynoSchedulingOptions"));

var _DynoSchedulingFormSpacing = _interopRequireDefault(require("./DynoSchedulingFormSpacing"));

var _SchedulingTimezone = _interopRequireDefault(require("./SchedulingTimezone"));

var _DynoScheduling = require("lead-flows-ui/constants/DynoScheduling");

var DynoScheduling =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DynoScheduling, _PureComponent);
  (0, _createClass2.default)(DynoScheduling, null, [{
    key: "propTypes",
    get: function get() {
      return {
        isPublished: _react.PropTypes.bool.isRequired,
        publishAt: _react.PropTypes.number,
        unpublishAt: _react.PropTypes.number,
        publishedAt: _react.PropTypes.number,
        unpublisedhAt: _react.PropTypes.number,
        error: _react.default.PropTypes.object,
        onChange: _react.PropTypes.func.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired
      };
    }
  }]);

  function DynoScheduling(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DynoScheduling);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoScheduling).call(this));
    _this.state = (0, _extends2.default)({}, _this.deriveInitialStateFromProps(props));
    _this.clearOptions = _this.clearOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearScheduling = _this.clearScheduling.bind((0, _assertThisInitialized2.default)(_this));
    _this.deriveInitialStateFromProps = _this.deriveInitialStateFromProps.bind((0, _assertThisInitialized2.default)(_this));
    _this.deriveStateFromProps = _this.deriveStateFromProps.bind((0, _assertThisInitialized2.default)(_this));
    _this.formatedMessage = _this.formatedMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.getMinUnpublishDate = _this.getMinUnpublishDate.bind((0, _assertThisInitialized2.default)(_this));
    _this.getNextTimeSlot = _this.getNextTimeSlot.bind((0, _assertThisInitialized2.default)(_this));
    _this.getNow = _this.getNow.bind((0, _assertThisInitialized2.default)(_this));
    _this.getOffsetDate = _this.getOffsetDate.bind((0, _assertThisInitialized2.default)(_this));
    _this.getTimeSlot = _this.getTimeSlot.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionChange = _this.handleOptionChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePublishAtChange = _this.handlePublishAtChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleScheduleUnpublishChange = _this.handleScheduleUnpublishChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUnpublishAtChange = _this.handleUnpublishAtChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.langKey = _this.langKey.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderError = _this.maybeRenderError.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderUnpublish = _this.maybeRenderUnpublish.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderUnpublishOption = _this.maybeRenderUnpublishOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderPublishedAt = _this.renderPublishedAt.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderScheduling = _this.renderScheduling.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderTimezone = _this.renderTimezone.bind((0, _assertThisInitialized2.default)(_this));
    _this.setDefaultPublishAt = _this.setDefaultPublishAt.bind((0, _assertThisInitialized2.default)(_this));
    _this.setDefaultScheduleUnpublishOption = _this.setDefaultScheduleUnpublishOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.setDefaultUnpublishAt = _this.setDefaultUnpublishAt.bind((0, _assertThisInitialized2.default)(_this));
    _this.validatePublishAt = _this.validatePublishAt.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateUnpublishAt = _this.validateUnpublishAt.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DynoScheduling, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var wasUnpublished = this.props.isPublished === true && nextProps.isPublished === false;

      if (wasUnpublished) {
        this.clearOptions();
      }

      this.setState((0, _extends2.default)({}, this.deriveStateFromProps(nextProps)));
    }
  }, {
    key: "deriveInitialStateFromProps",
    value: function deriveInitialStateFromProps(props) {
      var isPublished = props.isPublished,
          unpublishAt = props.unpublishAt,
          publishAt = props.publishAt;
      var scheduleChecked = !isPublished && Boolean(publishAt) || Boolean(unpublishAt);
      var scheduleUnpublishChecked = isPublished && scheduleChecked || Boolean(unpublishAt);
      return (0, _extends2.default)({
        scheduleChecked: scheduleChecked,
        scheduleUnpublishChecked: scheduleUnpublishChecked
      }, this.deriveStateFromProps(props));
    }
  }, {
    key: "deriveStateFromProps",
    value: function deriveStateFromProps(props) {
      var isPublished = props.isPublished,
          publishAt = props.publishAt,
          unpublishAt = props.unpublishAt;

      var now = _I18n.default.moment.utc().valueOf();

      var minPublishAt = this.getOffsetDate(now);
      var minUnpublishAt = isPublished ? now : this.getMinUnpublishDate(publishAt);
      var maxPublishAt = this.getTimeSlot(_I18n.default.moment.utc(unpublishAt)) - _DynoScheduling.TIMEPICKER_INTERVAL * 60;
      return {
        schedulePublishDisabled: isPublished,
        minPublishAt: minPublishAt,
        minUnpublishAt: minUnpublishAt,
        maxPublishAt: maxPublishAt
      };
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor.scheduling." + suffix;
    }
  }, {
    key: "formatedMessage",
    value: function formatedMessage(suffix) {
      var overideSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _react.default.createElement(_FormattedMessage.default, {
        message: overideSuffix ? suffix : this.langKey(suffix)
      });
    } // actions

  }, {
    key: "handleOptionChange",
    value: function handleOptionChange(scheduleChecked) {
      if (!scheduleChecked) {
        this.clearScheduling();
      } else {
        this.setDefaultScheduleUnpublishOption();
        this.setDefaultPublishAt();
      }

      this.setState({
        scheduleChecked: scheduleChecked
      });
      return null;
    }
  }, {
    key: "handleScheduleUnpublishChange",
    value: function handleScheduleUnpublishChange(_ref) {
      var checked = _ref.target.checked;

      if (!checked) {
        this.handleChange({
          unpublishAt: null
        });
      } else {
        this.setDefaultUnpublishAt();
      }

      this.setState({
        scheduleUnpublishChecked: checked
      });
    }
  }, {
    key: "handlePublishAtChange",
    value: function handlePublishAtChange(newPublishAt) {
      var minPublishAt = this.state.minPublishAt;
      var offsetPublishAt = this.getOffsetDate(newPublishAt);
      var publishAt = newPublishAt < minPublishAt ? minPublishAt : offsetPublishAt;
      this.handleChange({
        publishAt: publishAt
      });
    }
  }, {
    key: "handleUnpublishAtChange",
    value: function handleUnpublishAtChange(newUnpublishAt) {
      var minUnpublishAt = this.state.minUnpublishAt;
      var offsetPublishAt = this.getOffsetDate(minUnpublishAt);
      var unpublishAt = newUnpublishAt < minUnpublishAt ? offsetPublishAt : newUnpublishAt;
      this.handleChange({
        unpublishAt: unpublishAt
      });
    } // methods

  }, {
    key: "clearOptions",
    value: function clearOptions() {
      this.setState({
        scheduleChecked: false,
        scheduleUnpublishChecked: false,
        schedulePublishDisabled: false
      });
    }
  }, {
    key: "clearScheduling",
    value: function clearScheduling() {
      var isPublished = this.props.isPublished;
      this.handleChange({
        publishAt: null,
        unpublishAt: null
      });

      if (!isPublished) {
        this.setState({
          scheduleUnpublishChecked: false
        });
      }
    }
  }, {
    key: "setDefaultPublishAt",
    value: function setDefaultPublishAt() {
      var isPublished = this.props.isPublished;

      if (!isPublished) {
        var nextTimeSlot = this.getNextTimeSlot();

        var publishAt = _I18n.default.moment(nextTimeSlot).add(_DynoScheduling.DEFAULT_PUBLISH_AT_OFFSET, 'minutes').valueOf();

        this.handleChange({
          publishAt: publishAt
        });
      }
    }
  }, {
    key: "setDefaultScheduleUnpublishOption",
    value: function setDefaultScheduleUnpublishOption() {
      var isPublished = this.props.isPublished;
      this.setState({
        scheduleUnpublishChecked: isPublished
      });
    }
  }, {
    key: "setDefaultUnpublishAt",
    value: function setDefaultUnpublishAt() {
      var publishAt = this.props.publishAt;

      if (publishAt) {
        var unpublishAt = _I18n.default.moment.utc(publishAt).add(_DynoScheduling.DEFAULT_TIME_DIFFERENCE, 'minutes').valueOf();

        this.handleChange({
          unpublishAt: unpublishAt
        });
      }
    }
  }, {
    key: "getNow",
    value: function getNow() {
      return _I18n.default.moment.utc();
    }
  }, {
    key: "getNextTimeSlot",
    value: function getNextTimeSlot() {
      return this.getTimeSlot(this.getNow());
    }
  }, {
    key: "getTimeSlot",
    value: function getTimeSlot(momentTime) {
      var roundedUp = Math.ceil(momentTime.minute() / _DynoScheduling.TIMEPICKER_INTERVAL) * _DynoScheduling.TIMEPICKER_INTERVAL;

      var nextTimeSlot = momentTime.minute(roundedUp).second(0).valueOf();
      return nextTimeSlot;
    }
  }, {
    key: "getOffsetDate",
    value: function getOffsetDate(date) {
      var momentDate = _I18n.default.moment.utc(date);

      var roundedUp = Math.ceil(momentDate.minute() / _DynoScheduling.TIMEPICKER_INTERVAL) * _DynoScheduling.TIMEPICKER_INTERVAL;

      return momentDate.minute(roundedUp).second(0).valueOf();
    }
  }, {
    key: "getMinUnpublishDate",
    value: function getMinUnpublishDate(publishAt) {
      return publishAt ? _I18n.default.moment.utc(publishAt).add(_DynoScheduling.TIMEPICKER_INTERVAL, 'minutes').valueOf() : undefined;
    }
  }, {
    key: "validatePublishAt",
    value: function validatePublishAt() {
      var _this$props = this.props,
          isPublished = _this$props.isPublished,
          addValidationError = _this$props.addValidationError,
          removeValidationError = _this$props.removeValidationError;
      var publishAt = this.props.publishAt;
      var scheduleUnpublishChecked = this.state.scheduleUnpublishChecked;
      var isPublishAtEmpty = !Boolean(publishAt);

      if (!isPublished && scheduleUnpublishChecked && isPublishAtEmpty) {
        addValidationError('publishAt', this.langKey('error.selectPublishAt'));
      } else {
        removeValidationError('publishAt');
      }
    }
  }, {
    key: "validateUnpublishAt",
    value: function validateUnpublishAt() {
      var _this$props2 = this.props,
          addValidationError = _this$props2.addValidationError,
          removeValidationError = _this$props2.removeValidationError;
      var _this$props3 = this.props,
          publishAt = _this$props3.publishAt,
          unpublishAt = _this$props3.unpublishAt;

      if (publishAt !== null && unpublishAt !== null && publishAt >= unpublishAt) {
        addValidationError('unpublishAt', this.langKey('error.invalidDateRange'));
      } else {
        removeValidationError('unpublishAt');
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(props) {
      this.props.onChange(props);
    } // render

  }, {
    key: "maybeRenderError",
    value: function maybeRenderError(key) {
      var error = this.props.error;
      var displayError = error && key in error;
      return displayError ? _react.default.createElement(_UIBox.default, {
        className: "dyno-scheduling__error m-top-1"
      }, _react.default.createElement(_Small.default, {
        use: "error"
      }, this.formatedMessage(error[key], true))) : null;
    }
  }, {
    key: "maybeRenderUnpublish",
    value: function maybeRenderUnpublish() {
      var _this$props4 = this.props,
          unpublishAt = _this$props4.unpublishAt,
          error = _this$props4.error;
      var _this$state = this.state,
          scheduleUnpublishChecked = _this$state.scheduleUnpublishChecked,
          minUnpublishAt = _this$state.minUnpublishAt;
      return scheduleUnpublishChecked ? _react.default.createElement(_UIBox.default, {
        className: "dyno-scheduling__unpublish-form",
        grow: 0
      }, _react.default.createElement(_UIFlex.default, {
        align: "end"
      }, _react.default.createElement(_DynoSchedulingFormSpacing.default, null), _react.default.createElement(_UIBox.default, null, _react.default.createElement(_DynoSchedulingForm.default, {
        dateLabel: this.formatedMessage('endDate'),
        timeLabel: this.formatedMessage('time'),
        minValue: minUnpublishAt,
        error: Boolean(error.unpublishAt),
        value: unpublishAt,
        handleUpdate: this.handleUnpublishAtChange
      })))) : null;
    }
  }, {
    key: "maybeRenderUnpublishOption",
    value: function maybeRenderUnpublishOption() {
      var _this$state2 = this.state,
          scheduleChecked = _this$state2.scheduleChecked,
          schedulePublishDisabled = _this$state2.schedulePublishDisabled,
          scheduleUnpublishChecked = _this$state2.scheduleUnpublishChecked;
      return scheduleChecked ? _react.default.createElement(_UICheckbox.default, {
        className: "dyno-scheduling__unpublish-option",
        disabled: schedulePublishDisabled,
        checked: scheduleUnpublishChecked,
        onChange: this.handleScheduleUnpublishChange
      }, this.formatedMessage('setUnpublishDateAndTime')) : null;
    }
  }, {
    key: "renderPublishedAt",
    value: function renderPublishedAt() {
      var publishedAt = this.props.publishedAt;
      return _react.default.createElement(_UITooltip.default, {
        title: this.formatedMessage('publishedTooltip')
      }, _react.default.createElement(_UIBox.default, {
        className: "dyno-scheduling__published-at",
        grow: 0
      }, _react.default.createElement(_DynoSchedulingForm.default, {
        dateLabel: this.formatedMessage('startDate'),
        timeLabel: this.formatedMessage('time'),
        timeInterval: 1,
        minValue: publishedAt,
        value: publishedAt,
        disabled: true
      })));
    }
  }, {
    key: "renderScheduling",
    value: function renderScheduling() {
      var _this$props5 = this.props,
          publishAt = _this$props5.publishAt,
          error = _this$props5.error;
      var _this$state3 = this.state,
          schedulePublishDisabled = _this$state3.schedulePublishDisabled,
          minPublishAt = _this$state3.minPublishAt,
          maxPublishAt = _this$state3.maxPublishAt;
      return _react.default.createElement(_UIBox.default, {
        className: "dyno-scheduling__publish-form",
        grow: 0
      }, _react.default.createElement(_DynoSchedulingForm.default, {
        dateLabel: this.formatedMessage('startDate'),
        timeLabel: this.formatedMessage('time'),
        minValue: minPublishAt,
        maxValue: maxPublishAt,
        maxValueValidationMessage: this.formatedMessage('publishAtMaxValidationMessage'),
        value: publishAt,
        disabled: schedulePublishDisabled,
        error: Boolean(error.publishAt),
        handleUpdate: this.handlePublishAtChange
      }));
    }
  }, {
    key: "renderTimezone",
    value: function renderTimezone() {
      var scheduleUnpublishChecked = this.state.scheduleUnpublishChecked;
      var format = scheduleUnpublishChecked ? 'small' : null;
      return _react.default.createElement(_UIBox.default, {
        className: "m-left-3 m-bottom-2",
        grow: 0
      }, _react.default.createElement(_SchedulingTimezone.default, {
        format: format
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.validateUnpublishAt();
      this.validatePublishAt();
    }
  }, {
    key: "render",
    value: function render() {
      var isPublished = this.props.isPublished;
      var scheduleChecked = this.state.scheduleChecked;
      return _react.default.createElement(_UIBox.default, {
        className: "dyno-scheduling"
      }, _react.default.createElement(_DynoSchedulingOptions.default, {
        className: "dyno-scheduling__options",
        formatedMessage: this.formatedMessage,
        isPublished: isPublished,
        value: scheduleChecked,
        handleUpdate: this.handleOptionChange
      }), scheduleChecked ? _react.default.createElement(_UIBox.default, {
        className: "justify-start align-end"
      }, isPublished ? this.renderPublishedAt() : this.renderScheduling(), this.maybeRenderUnpublish(), this.renderTimezone()) : '', this.maybeRenderError('publishAt'), this.maybeRenderError('unpublishAt'), this.maybeRenderUnpublishOption());
    }
  }]);
  return DynoScheduling;
}(_react.PureComponent);

exports.default = DynoScheduling;
module.exports = exports.default;